import {StepPayload} from '@blesk-frontend/api';
import {createStore} from 'zustand';

export interface ImageEditorState {
  step: StepPayload | null;
  setStep: (step: StepPayload) => void;
}

export type ImageEditorStore = ReturnType<typeof createImageEditorStore>;

export const createImageEditorStore = ({step}: {step: StepPayload | null}) => {
  return createStore<ImageEditorState>()((set) => ({
    step,
    setStep: (step) => {
      set({step});
    },
  }));
};
